import { Button } from '@/components/ui/button';
import { menu } from '@/routes';
import { Link, usePage } from '@inertiajs/react';

interface CategoryButtonsProps {
    categories: App.Data.MenuItemTypeData[];
}

const CategoryButtons = ({ categories }: CategoryButtonsProps) => {
    const { type } = usePage().props.filters as { type: string | null };

    const activeType =
        categories.find(({ slug }) => slug?.toString() === type?.toString())
            ?.slug || 'all';

    return (
        <div className="mb-3 flex items-center gap-3">
            <Link
                href={menu()}
                data={{ type: undefined, category_id: undefined }}
                preserveScroll
            >
                <Button
                    variant={activeType === 'all' ? 'default' : 'secondary'}
                    size="sm"
                    className="text-xs capitalize md:text-sm"
                >
                    All
                </Button>
            </Link>

            <div className="h-6 w-px bg-primary/20" />

            <div className="scrollbar-hide flex items-center gap-2 overflow-x-auto">
                {categories.map((category) => (
                    <Link
                        key={category.id}
                        href={menu()}
                        data={{
                            type: category.slug,
                            category_id: undefined,
                        }}
                        preserveScroll
                    >
                        <Button
                            variant={
                                activeType === category.slug
                                    ? 'default'
                                    : 'secondary'
                            }
                            size="sm"
                            className="text-xs whitespace-nowrap capitalize md:text-sm"
                        >
                            {category.name}
                        </Button>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default CategoryButtons;
